module.exports = __webpack_public_path__ + "img/BN.690446b8.png";